import React, { useState } from 'react';
import { Typeahead, noop } from '@panwds/react-ui';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';
import { Pill } from '../Pill/Pill.esm.js';
import '../Pill/PillValue.esm.js';

function TypeAheadFilter({ name, required = false, onClose, onClear, onKeyUp, dataMetrics, dataTestId, label = "", id = "type-ahead-filter", ...rest }) {
    const { setFilters, filters } = useFilters();
    // This exists for the parent component to query the input value for results
    // No need to set an initial state because keyup will get the input value - User provided value
    const [input, setInput] = useState("");
    const handleInputChange = (txt) => setInput(txt);
    const onKeyUpGetInput = (event) => {
        onKeyUp(event, input);
    };
    // Send drop down selections to global filter state
    const onChange = (value) => {
        setFilters({ [name]: value.label });
    };
    const onFilterCloseAndOptionsClear = (e) => {
        onClose === null || onClose === void 0 ? void 0 : onClose(e);
        onClear === null || onClear === void 0 ? void 0 : onClear();
    };
    return (React.createElement("div", { id: id },
        React.createElement(Pill, { label: label, required: required, onClose: onFilterCloseAndOptionsClear, select: React.createElement(Typeahead, { ...rest, addInputClassName: "tw-ml-2 tw-border-none tw-h-full", onChange: onChange, onClose: noop, onInputChange: handleInputChange, onKeyUp: onKeyUpGetInput, defaultValue: filters[name], dataMetrics: `type-ahead-filter-${dataMetrics || name}`, dataTestId: `type-ahead-filter-${dataTestId || name}` }) })));
}

export { TypeAheadFilter };
//# sourceMappingURL=TypeAheadFilter.esm.js.map
